<script lang="ts">
  import { defineComponent } from "vue";
  import SectionEtablissementCommercial from '@/generated/sections/SectionEtablissementCommercial.vue';
  import { storeSession } from '@/generated/stores';
  import UserProfile, { EnumProfile } from '@/framework/base/classes/UserProfile';
  export default defineComponent({
    extends: SectionEtablissementCommercial,
    components: {},
    computed: {
      canManageUserAccess(): boolean {
        const user = storeSession.connectedUser;
        return user != null && (
          UserProfile.hasProfile(user, EnumProfile.admin) ||
          UserProfile.hasProfile(user, EnumProfile.superAdmin)
        );
      }
    },
    methods: {
      readOnly (value: string): boolean {
        let res = false;
        if (!this.editEtablissement.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("SIRET", true);
          this.readOnlyMap.set("ALIAS", true);
          this.readOnlyMap.set("NOM", true);
          this.readOnlyMap.set("COMMERCIAL_ID", false);
          this.readOnlyMap.set("USER_DISABLED", !this.canManageUserAccess);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed(value: string): boolean {
        if (value == "USER_DISABLED") {
          return this.canManageUserAccess;
        }
        return true;
      },

    }
  })
</script>
